import { useTranslation } from 'react-i18next';

import WhyBox from '@/components/ui/WhyBox';
import type { Project } from '@/hooks/useProject';

/**
 * Result of turning the screenplay into the production bible — the structured
 * shooting script the crew actually works from. If this didn't pass validation,
 * nothing downstream will be right, so it sits at the top of the page.
 */
export default function TranslationReportBanner({ report }: { report: Project['translation_report'] }) {
  const { t } = useTranslation('dashboard');
  if (!report) return null;

  const runtimeMin = Math.round((report.estimated_runtime_seconds ?? 0) / 60);

  return (
    <WhyBox variant={report.ok ? 'info' : 'danger'} title={report.ok ? t('bible.readyTitle') : t('bible.failedTitle')}>
      {report.ok ? (
        t('bible.ready', {
          scenes: report.scenes ?? 0,
          shots: report.shots ?? 0,
          aRoll: report.host_a_roll ?? 0,
          bRoll: report.b_roll ?? 0,
          minutes: runtimeMin,
        })
      ) : (
        <>
          {t('bible.failed')}
          <ul className="mt-1.5 list-disc space-y-0.5 pl-5">
            {(report.issues ?? []).slice(0, 6).map((iss, i) => (
              <li key={i}>{iss}</li>
            ))}
          </ul>
        </>
      )}
    </WhyBox>
  );
}
